export default __webpack_public_path__ + "static/logo-aranalfe-b5a9fd87e250deaba5f0a064554ab699.png";